import Component from '../core/Component'
import { queries } from '../core/config'


const MOBILE_DOT_ANIMATION_TIME = 4500 //musi byt byt vic, nez delka animace v css

export default class HeroSlider extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            cards: [],
            dots: [],
            cardLinks: [],
        }

        this.timer = null
        this.index = null
    }

    prepare() {
        this.ref.dots.forEach((dot, index) => {
            dot.addEventListener('animationend', this.handleDotAnimationEnd)
            dot.addEventListener('click', () => this.handleDotClick(index))
        })
        this.ref.cards.forEach((card) => {
            card.addEventListener('mouseover', this.handleCardMouseOver)
            card.addEventListener('mouseleave', this.handleCardMouseLeave)
        })

        this.ref.cardLinks.forEach((cardLink) => {
            cardLink.addEventListener('focus', this.handleCardLinkFocus)
        })

        this.index = 0
        this.runAnimationToNext()
    }

    destroy() {
        clearTimeout(this.timer)
    }

    handleCardMouseLeave = () => {
        this.resumeAnimationToNext()
    }

    handleDotAnimationEnd = () => {
        clearTimeout(this.timer)
        this.next()
    }

    handleDotClick = (index) => {
        this.select(index)
    }

    handleCardLinkFocus = (event) => {
        const index = this.ref.cardLinks.findIndex(cardLink => cardLink === event.currentTarget)
        this.select(index)
    }

    handleCardMouseOver = (event) => {
        if (event.target.closest('a')) {
            this.pauseAnimationToNext()
        } else {
            this.resumeAnimationToNext()
        }
    }

    select(index) {
        if (this.index === index) {
            return
        }

        const card = this.ref.cards[index]
        const dot = this.ref.dots[index]
        if (card && dot) {
            this.ref.cards.forEach(card => card.classList.remove('is-activenow'))
            this.ref.dots.forEach(dot => dot.classList.remove('is-activenow', 'is-animating', 'is-paused'))
            card.classList.add('is-activenow')
            dot.classList.add('is-activenow')
        }

        this.index = index
        this.runAnimationToNext()
    }

    next() {
        let index = this.index + 1
        if (index >= this.ref.cards.length) {
            index = 0
        }
        this.select(index)
    }

    pauseAnimationToNext() {
        const dot = this.ref.dots[this.index]
        if (!dot) {
            return
        }

        clearTimeout(this.timer)
        dot.classList.add('is-paused')
    }

    resumeAnimationToNext() {
        const dot = this.ref.dots[this.index]
        if (!dot) {
            return
        }

        clearTimeout(this.timer)
        dot.classList.remove('is-paused')

        if (window.matchMedia(queries.largeUp).matches) {
            return
        }
        this.timer = setTimeout(() => {
            this.next()
        }, MOBILE_DOT_ANIMATION_TIME)
    }

    runAnimationToNext() {
        const dot = this.ref.dots[this.index]
        if (!dot) {
            return
        }

        clearTimeout(this.timer)
        dot.classList.add('is-animating')

        if (window.matchMedia(queries.largeUp).matches) {
            return
        }
        this.timer = setTimeout(() => {
            this.next()
        }, MOBILE_DOT_ANIMATION_TIME)
    }


}